import { Trans } from 'react-i18next';
import VideoPoster from '../../assets/9970a1d460cde225.jpg';
import Video from '../../assets/9970a1d460cde225.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const CryogenicPipingSection1 = () => {
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile, isPad } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: '#1e1e1e',
      ...(isMobile && !isPad ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: isMobile && !isPad ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            left: `${padding}px`,   // ✅ 좌측 여백
            bottom: (isMobile && !isPad) ? isEng ? '202px' : isChina ? '141px' : '163px' : `${topSectionBottom}px`,
            transform: isPad ? 'scale(0.80)' : 'scale(1)',
            transformOrigin: 'left bottom',
          }}
        >Cryogenic<br />Piping</SubH1>
        <H10
          style={{
            width: isMobile && !isPad ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile && !isPad ? '0px' : `${topSectionBottom}px`,
            left: isMobile && !isPad ? `${padding}px` : undefined,
            right: isMobile && !isPad ? undefined : `${padding}px`,
            transform: isPad ? 'scale(0.85)' : 'scale(1)',
            transformOrigin: 'right bottom',
            ...(isMobile && !isPad
              && { height: isEng ? '190px' : isChina ? `124px` : `146px` }),
          }}
        >
          <Trans i18nKey='비비테크는 LNG, 액체질소 등 극저온 유체의 안정적인 플로우를 위해 고내구성·고정밀 배관 시스템을 설계 및 시공합니다. 온도 변화에 민감한 첨단 공정에서도 안정성과 효율성을 확보하며, 초정밀 산업을 위한 핵심 유틸리티 인프라를 제공합니다.'/>
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default CryogenicPipingSection1;
